module.exports = __webpack_public_path__ + "img/contact_line.463b388f.svg";